function GetCustomField(key, obj = [], path = '') {
  let target = obj.find(f => f.key === key)
  if (!target) return

  return RPath(['data', ...(path ? path.split('.') : [])], target)
}

function SplitHtml(value, pattern = '<h2>') {
  if (!value) return []
  let splitter = '<<SPLITTER>>'
  let regex = new RegExp(pattern, 'g')
  return value
    .replace(regex, splitter + pattern)
    .split(splitter)
    .filter(Boolean)
}

function Capitalize(value) {
  return value.charAt(0).toUpperCase() + value.substring(1)
}

export { SplitHtml, GetCustomField, Capitalize }
